import { render, staticRenderFns } from "./LinkPhone.vue?vue&type=template&id=55ae015a&"
import script from "./LinkPhone.vue?vue&type=script&lang=js&"
export * from "./LinkPhone.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports